export enum ComponentType {
  SWIMLANE = "Swimlane",
  STEP = "Step",
  FIELD = "Field",
  PROCESS = "Process"
}

export enum SDOComponentType {
  OBJECT = "Object",
  SECTION = "ObjectSection",
  FIELD = "ObjectField",
  OBJECT_RELATIONSHIPS_NODE = "ObjectRelationshipsNode",
  OBJECT_RELATIONSHIP = "ObjectRelationship"
}
